// https://github.com/eKoopmans/html2pdf
import html2pdf from 'html2pdf.js'

class FichePrinter {
  element = null

  constructor(element) {
    this.element = element
  }

  execute(numero) {
    let filename = 'cartoradio_' + numero + '.pdf'

    html2pdf(this.element, {
      filename: filename,
      image: {
        type: 'jpeg',
        quality: 0.98
      },
      enableLinks: false,
      html2canvas: {
        dpi: 192,
        letterRendering: true
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait'
      }
    })
  }
}

export default FichePrinter
